import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { RequestTypes } from '../requestTypes'
import { documentEngineTemplateKeys } from '../documentEngineTemplateKeys'
import { documentEngineTemplatesKeys } from '../../documentEngineTemplatesKeys'
import { IAppNotification } from '@core/entities/notifications'

export const useDeleteDocumentEngineTemplate = (
  options?: UseMutationOptions<
    IAppNotification,
    RequestErrorType,
    RequestTypes['deleteDocumentEngineTemplate']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...documentEngineTemplateKeys.deleteDocumentEngineTemplate,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: documentEngineTemplatesKeys.byOrganisation({
          organisationId: variables.organisationId,
        }).queryKey,
      })
    },
    ...options,
  })
}
